import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa"; // make sure to install react-icons
import { motion } from "framer-motion";
import "./UserAlertHistory.css";
import "./EditProfile.css"; // <-- add this
import homeIcon from "../images/home.png";
import profileIcon from "../images/edit-profile-active.png";
import alertIcon from "../images/alert.png"; // keep this if you want consistent icons
import { Link } from "react-router-dom"; // <-- add this
import personalIcon from "../images/personal.png";
import pinIcon from "../images/pin.png";
import contactsIcon from "../images/contacts.png";


export default function EditProfile() {
  const storedUser = JSON.parse(localStorage.getItem("userData"));
  const userId = storedUser?.id;

  const token = storedUser?.token;

  const [user, setUser] = useState(storedUser || null);

  // Modals
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  const [showPinModal, setShowPinModal] = useState(false);
  const [showContactsModal, setShowContactsModal] = useState(false);

  // Personal
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [password, setPassword] = useState("");

  // PIN
  const [pin, setPin] = useState("");

  // Contacts
  const [contacts, setContacts] = useState([]);
  const [contactInputs, setContactInputs] = useState({}); // local editable inputs
  const [newContact, setNewContact] = useState({ contactName: "", phoneNumber: "" }); // <-- add this
  const [selectedContact, setSelectedContact] = useState(null); // null = none selected

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const listItemStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "20px 15px",   // more spacing
  background: "transparent",
  color: "#fff",          // white text
};

const leftSideStyle = {
  display: "flex",
  alignItems: "center",
  gap: "20px",            // more spacing between icon & text
};

const iconStyle = {
  width: "62px",          // larger icon size
  height: "62px",
  background: "transparent", // placeholder until icons are added
  borderRadius: "8px",
};

const arrowStyle = {
  cursor: "pointer",
  fontSize: "26px",       // slightly bigger arrow
  color: "#fff",          // white arrow
  fontWeight: "bold",
};

const dividerStyle = {
  border: "none",
  borderTop: "1px lightgray solid",
  margin: "0 10px",       // indents divider slightly
};


  useEffect(() => {
    if (user) fetchContacts(user.id);
  }, [user]);

  // ---------------- FETCH CONTACTS ----------------
  const fetchContacts = async (userId) => {
    try {
      const res = await fetch(
        `https://senu-app.azurewebsites.net/api/users/${userId}/contacts`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          
        }
      );
      if (!res.ok) throw new Error("Failed to load contacts");
      const data = await res.json();
      setContacts(data);

      // Initialize editable inputs
      const inputs = {};
      data.forEach((c) => {
        inputs[c.id] = { contactName: c.contactName, phoneNumber: c.phoneNumber };
      });
      setContactInputs(inputs);
    } catch (err) {
      setError(err.message);
    }
  };

  // ---------------- SAVE PERSONAL ----------------
  const handleSavePersonal = async () => {
    setError("");
    setSuccess("");
    try {
      const response = await fetch(
        `https://senu-app.azurewebsites.net/api/users/${user.id}/update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name,
            email,
            password: password || undefined,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update profile");

      const updated = await response.json();
      localStorage.setItem("userData", JSON.stringify({ ...user, ...updated.user, token }));
      setUser({ ...user, ...updated.user });
      setSuccess("Profile updated successfully!");
      setShowPersonalModal(false);
      setPassword("");
    } catch (err) {
      setError(err.message);
    }
  };

  // ---------------- SAVE PIN ----------------
  const handleSavePin = async () => {
    setError("");
    setSuccess("");
    if (pin.length !== 4) {
      setError("PIN must be 4 digits");
      return;
    }

    try {
      const res = await fetch(
        `https://senu-app.azurewebsites.net/api/users/${user.id}/update-pin`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(pin), // backend reads a plain string
        }
      );
      if (!res.ok) throw new Error("Failed to update PIN");
      setSuccess("PIN updated successfully!");
      setShowPinModal(false);
      setPin("");
    } catch (err) {
      setError(err.message);
    }
  };

  // ---------------- CONTACTS ----------------
  
  const handleAddContact = async () => {
  try {
    if (!newContact?.contactName || !newContact?.phoneNumber) {
      alert("Name and Phone Number are required");
      return;
    }

    // South African phone number validation
    const saPhoneRegex = /^(?:\+27|0)[1-9][0-9]{8}$/;
    if (!saPhoneRegex.test(newContact.phoneNumber)) {
      alert("Please enter a valid South African phone number");
      return;
    }

    const contactPayload = {
      ContactName: newContact.contactName,
      PhoneNumber: newContact.phoneNumber,
      UserId: user.id,
    };

    const response = await fetch(
      `https://senu-app.azurewebsites.net/api/users/${user.id}/contacts`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(contactPayload),
      }
    );

    if (!response.ok) throw new Error("Failed to add contact");
    const data = await response.json();

    setContacts([...contacts, data]); // append new contact
    setNewContact({ contactName: "", phoneNumber: "" }); // reset form
  } catch (err) {
    setError(err.message);
  }
};


  const handleUpdateContact = async (id) => {
  try {
    const contactPayload = {
      ContactName: selectedContact.contactName,
      PhoneNumber: selectedContact.phoneNumber,
      UserId: user.id,
    };

    const response = await fetch(
      `https://senu-app.azurewebsites.net/api/users/${user.id}/contacts/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(contactPayload),
      }
    );

    if (!response.ok) throw new Error("Failed to update contact");

    const data = await response.json();

    setContacts(contacts.map((c) => (c.id === id ? data : c)));
    setSelectedContact(null); // go back to list mode
  } catch (err) {
    setError(err.message);
  }
};


  const handleDeleteContact = async (id) => {
    try {
      const res = await fetch(
        `https://senu-app.azurewebsites.net/api/users/contacts/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Failed to delete contact");
      setContacts(contacts.filter((c) => c.id !== id));
      const newInputs = { ...contactInputs };
      delete newInputs[id];
      setContactInputs(newInputs);
      setSuccess("Contact deleted successfully!");
    } catch (err) {
      setError(err.message);
    }
  };

  if (!user) return null;

  return (
  <div className="user-alert-container">
    <div style={{ padding: "0px" }}>
                  {/* Top bar */}
        <div className="top-bar">
          <button className="back-button" onClick={() => navigate("/home")}>
            ← Back
          </button>
          <h2>My Profile</h2>
        </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {/* Settings List */}
<div style={{ display: "flex", flexDirection: "column" }}>
  {/* Personal Details */}
  <div style={listItemStyle}>
    <div style={leftSideStyle}>
      <img src={personalIcon} alt="Personal" style={iconStyle} /> {/* Icon goes here */}
      <span>Personal Details</span>
    </div>
    <span style={arrowStyle} onClick={() => setShowPersonalModal(true)}>
      &gt;
    </span>
  </div>
  <hr style={dividerStyle} />

  {/* Security PIN */}
  <div style={listItemStyle}>
    <div style={leftSideStyle}>
      <img src={pinIcon} alt="PIN" style={iconStyle} /> {/* Icon goes here */}
      <span>Security PIN</span>
    </div>
    <span style={arrowStyle} onClick={() => setShowPinModal(true)}>
      &gt;
    </span>
  </div>
  <hr style={dividerStyle} />

  {/* Emergency Contacts */}
  <div style={listItemStyle}>
    <div style={leftSideStyle}>
      <img src={contactsIcon} alt="Contacts" style={iconStyle} />
 {/* Icon goes here */}
      <span>Emergency Contacts</span>
    </div>
    <span style={arrowStyle} onClick={() => setShowContactsModal(true)}>
      &gt;
    </span>
  </div>
</div>


      {/* ---------------- MODALS ---------------- */}
      {showPersonalModal && (
        <Modal onClose={() => setShowPersonalModal(false)}>
          <h3>Edit Personal Details</h3>
          <input
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={inputStyle}
          />
          <input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="New Password (optional)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
          <button style={btnStyle} onClick={handleSavePersonal}>
            Save
          </button>
        </Modal>
      )}

      {showPinModal && (
        <Modal onClose={() => setShowPinModal(false)}>
          <h3>Update PIN</h3>
          <input
            placeholder="4-digit PIN"
            value={pin}
            maxLength={4}
            onChange={(e) => setPin(e.target.value)}
            style={inputStyle}
          />
          <button style={btnStyle} onClick={handleSavePin}>
            Save
          </button>
        </Modal>
      )}

      {showContactsModal && (
        <Modal onClose={() => setShowContactsModal(false)}>
          <h3>Manage Emergency Contacts</h3>

          {/* Display message if no contacts */}
          {contacts.length === 0 && <p>No contacts yet.</p>}

          {/* Existing Contacts */}
          {contacts.map((c) => (
            <div
              key={c.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "10px 15px",
                marginBottom: "10px",
                background: "#fff",
                color: "#000",
              }}
            >
              {selectedContact?.id === c.id ? (
                <div style={{ flex: 1 }}>
                  <input
                    placeholder="Name"
                    value={contactInputs[c.id]?.contactName || ""}
                    onChange={(e) =>
                      setContactInputs({
                        ...contactInputs,
                        [c.id]: { ...contactInputs[c.id], contactName: e.target.value },
                      })
                    }
                    style={{ ...inputStyle, marginBottom: "5px" }}
                  />
                  <input
                    placeholder="Phone Number"
                    value={contactInputs[c.id]?.phoneNumber || ""}
                    onChange={(e) =>
                      setContactInputs({
                        ...contactInputs,
                        [c.id]: { ...contactInputs[c.id], phoneNumber: e.target.value },
                      })
                    }
                    style={inputStyle}
                  />
                  <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                    <button
                      style={{ ...btnStyle, flex: 1 }}
                      onClick={() => {
                        const phone = contactInputs[c.id].phoneNumber;
                        if (!/^0\d{9}$/.test(phone)) {
                          alert("Enter a valid South African phone number (10 digits starting with 0).");
                          return;
                        }
                        handleUpdateContact(c.id);
                        setSelectedContact(null);
                      }}
                    >
                      Save
                    </button>
                    <button
                      style={{ ...btnStyle, flex: 1, background: "crimson" }}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this contact?")) {
                          handleDeleteContact(c.id);
                        }
                      }}
                    >
                      Delete
                    </button>
                    <button
                      style={{ ...btnStyle, flex: 1, background: "#6c757d" }}
                      onClick={() => setSelectedContact(null)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div>
                    <strong>{c.contactName}</strong> - {c.phoneNumber}
                  </div>
                  <button
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                    onClick={() => setSelectedContact(c)}
                  >
                    <FaPencilAlt color="#007bff" />
                  </button>
                </>
              )}
            </div>
          ))}

          {/* Add New Contact */}
          <h4>Add New Contact</h4>
          <input
            placeholder="Name"
            value={newContact.contactName}
            onChange={(e) => setNewContact({ ...newContact, contactName: e.target.value })}
            style={inputStyle}
          />
          <input
            placeholder="Phone Number"
            value={newContact.phoneNumber}
            onChange={(e) => setNewContact({ ...newContact, phoneNumber: e.target.value })}
            style={inputStyle}
          />
          <button
            style={btnStyle}
            onClick={() => {
              if (!newContact.contactName || !newContact.phoneNumber) {
                alert("Both Name and Phone Number are required.");
                return;
              }
              if (!/^0\d{9}$/.test(newContact.phoneNumber)) {
                alert("Enter a valid South African phone number (10 digits starting with 0).");
                return;
              }
              handleAddContact(newContact);
              setNewContact({ contactName: "", phoneNumber: "" });
            }}
          >
            Add Contact
          </button>
        </Modal>
      )}
    </div>
    <nav className="bottom-nav">
      <Link to="/user-alert-history">
        <motion.img
          src={alertIcon}
          alt="Alert"
          className="nav-icon "
          layout
          animate={{ scale: 1, y: 0 }} // not highlighted
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        />
      </Link>

      <Link to="/home">
        <motion.img
              src={homeIcon}
              alt="Home"
              className="nav-icon home-center"
              layout
              animate={{ scale:  1, y : 1 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
            />
      </Link>

      <Link to="/profile">
        <motion.img
          src={profileIcon}
          alt="Profile"
          className="nav-icon center-icon"
          animate={{ scale: 1, y: -5 }} // highlighted because we are on profile
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        />
      </Link>
    </nav>
  </div>
);
}

/* ---------------- STYLES ---------------- */
const cardStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  textAlign: "center",
  minHeight: "200px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const btnStyle = {
  marginTop: "10px",
  padding: "10px 15px",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const inputStyle = {
  display: "block",
  width: "100%",
  padding: "8px",
  marginBottom: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

function Modal({ children, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          width: "400px",
          maxWidth: "90%",
        }}
      >
        {children}
        <button
          style={{
            ...btnStyle,
            background: "#6c757d",
            marginTop: "10px",
          }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
